module.exports = __webpack_public_path__ + "static/globalwar_indo-495152ea421cac02eda86aadaebbce6c.png";